<template>
   <div>
    <div v-for="playlist in playlists" :key="playlist.id">
      <div class="accordion-item" :id="'playlist-item-'+playlist.id" >
        <h2 class="accordion-header" :id="'flush-headingOne' + playlist.id">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            :data-bs-target="'#flush-collapseOne' + playlist.id" :aria-expanded="false"
            :aria-controls="'flush-collapseOne' + playlist.id" :data-playlist-id="playlist.id"
            :data-playlist-type="playlist.type" @click="fetchPlaylistData(playlist.id, playlist.type)">
            <i class='lar la-file-audio' style="margin-right:10px;font-size:25px;" v-if="playlist.type=='audio'" ></i>
            <i class='lar la-file-video' style="margin-right:10px;font-size:25px;" v-if="playlist.type=='video'" ></i>
            <span class="playlist-name" >
            {{ playlist.name }}
              </span>
            <span class="playlist-counts text-muted"
                            style="margin-left:10px">
                            {{
                            playlist?.type=='audio' ? playlist.songs_count:''
                            }} {{playlist.type=='audio'?'Audio':'Videos'}}{{playlist.songs_count>1?'s':''}}
                            <!-- {{$playlist->songs->count()}}
                            Audio{{$playlist->songs->count()>1?'s':''}} -->
                          </span>

          </button>
        </h2>
        <div :id="'flush-collapseOne' + playlist.id" class="accordion-collapse collapse"
          :aria-labelledby="'flush-headingOne' + playlist.id" data-bs-parent="#accordionFlushExample">
          <div class="accordion-body">
            <!-- <div :id="'playlist-data-' + playlist.id"> -->
               <library-playlist :playlist_id="playlist.id" :show_playlist_data="showPlaylistData[playlist.id]"  :playlist="playlistData" :paths="paths" @deleted="handeDeleted" @updatedName="handleUpdateName"></library-playlist> 
            <!-- </div> -->
            <div class="lds-dual-ring" :id="'loading-' + playlist.id"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import libraryPlaylist from "./library-playlist.vue";
export default {
    name: 'LibraryPlaylist',
    components: {
        libraryPlaylist
    },
  props: {
    playlists: {
      type: Array,
      required: true
    },
  },
 
  data() {
    return {
      playlistData: null,
      showPlaylistData: {},
      paths:{},

    };
  },
  methods: {
    handeDeleted(id){

      document.getElementById(`playlist-item-${id}`).remove()
    },
    handleUpdateName(id,name){
   document.getElementById(`flush-headingOne${id}`).querySelector('.playlist-name').innerHTML=name;
    },
    fetchPlaylistData(playlistId, playlistType) {
      const playlistDatas = document.getElementById(`playlist-data-${playlistId}`);
      const loading = document.getElementById(`loading-${playlistId}`);

      loading.style.display = 'block';
      this.$Progress.start();
      axios.get(`/user/playlist-item`, {
        params: {
          playlist_id: playlistId,
          playlist_type: playlistType
        }
      })
        .then(response => {
          loading.style.display = 'none';
          this.playlistData = response.data.playlistItems;
          this.paths={
            episodeLandscapePath:response.data.episodeLandscapePath,
            episodePortraitPath:response.data.episodePortraitPath,
            portraitPath:response.data.portraitPath,
            landscapePath:response.data.landscapePath,
            default:`/assets/images/default.png`,
          },
      this.showPlaylistData[playlistId] = true;

          this.$Progress.finish();          
        })
        .catch(error => {
          this.$Progress.fail();
          console.log(error);
        });
      },
      
      
    },
    created() {
      this.playlists.forEach(playlist => {
        this.showPlaylistData[playlist.id] = false;
      });
    },
  updated() {
    this.playlists.forEach(playlist => {
      this.showPlaylistData[playlist.id] = false;
    });
    

  },
  mouted(){
    // console.log(this.paths)
  }


};

</script>